import { COMMON_UPDATE_ERROR, COMMON_UPDATE_ERROR_GROUP, COMMON_UPDATE_EMPTY_ERROR } from '@/actions';

export const initialState = {
  error: {}
};

const commonReducers = (state = initialState, action) => {
  if (action.type === COMMON_UPDATE_ERROR) {
    return {
      ...state,
      error: action.error?.response?.data
    };
  }

  if (action.type === COMMON_UPDATE_ERROR_GROUP) {
    return {
      ...state,
      error: action.error
    };
  }

  if (action.type === COMMON_UPDATE_EMPTY_ERROR) {
    return {
      ...state,
      error: {}
    };
  }

  return state;
};

export default commonReducers;
